import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <section className="page">
      <h1>Not found</h1>
      <p className="text-muted">There is no page at this address.</p>
      <Link to="/">Back to Home</Link>
    </section>
  );
}
